import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

export const Divider = styled.hr(({ theme }) => ({
  margin: `${theme.space[5]}px 0`,
  border: 0,
  borderBottom: '1px solid #f5f5f5',

  [theme.mediaQueries.viewport7]: {
    display: 'none'
  }
}))

// Can we be more explicit with fontSize?
export const CommonTitle = styled.h1<StyledHTMLElement & { fontSize?: string }>(
  ({ theme, fontSize }) => ({
    fontSize: fontSize || '20px',
    fontFamily: theme.fonts.heading.family,
    fontWeight: 600
  })
)

export const VisibileToggleDiv = styled.div<{ isVisible: boolean }>(
  ({ isVisible }): CSSObject => ({
    opacity: isVisible ? 1 : 0,
    height: isVisible ? 'auto' : 0,
    transition: 'opacity 300ms ease-in',
    overflow: isVisible ? 'initial' : 'hidden'
  })
)
